import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const BedIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M2 10.5H14M2 10.5V8.5M2 10.5C1.44772 10.5 1 10.9477 1 11.5V14.8C1 14.9105 1.08954 15 1.2 15H2.85585C2.94193 15 3.01836 14.9449 3.04558 14.8632L3.22649 14.3205C3.38983 13.8305 3.84839 13.5 4.36491 13.5H11.8578C12.259 13.5 12.6337 13.7005 12.8562 14.0344L13.4406 14.9109C13.4777 14.9666 13.5402 15 13.607 15H14.8C14.9105 15 15 14.9105 15 14.8V11.5C15 10.9477 14.5523 10.5 14 10.5M2 1.5V2.5M14 10.5V8.5M14 1.5V2.5M2 2.5H14M2 2.5V8.5M14 2.5V8.5M2 8.5C2.16667 8.16667 2.7 7.5 3.5 7.5C3.71279 7.5 4.26046 7.5 5 7.5M14 8.5C14 7.7 13 7.5 12.5 7.5C12.0652 7.5 11.5542 7.5 11 7.5M11 7.5V5.7C11 5.03726 10.4627 4.5 9.8 4.5H6.2C5.53726 4.5 5 5.03726 5 5.7V7.5M11 7.5C9.05904 7.5 6.58748 7.5 5 7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
));
